(function () {
  const globalState = /** @type {{ __pouchesSoldCounterInitialized?: boolean }} */ (window);
  if (globalState.__pouchesSoldCounterInitialized) return;
  globalState.__pouchesSoldCounterInitialized = true;

  /** @param {string} position @param {string} value */
  const buildHalf = (position, value) => {
    const half = document.createElement('span');
    half.className = `pouches-counter__half pouches-counter__half--${position}`;
    const num = document.createElement('span');
    num.className = 'pouches-counter__num';
    num.textContent = value;
    half.appendChild(num);
    return half;
  };

  /** @param {string} position */
  const buildFlap = (position) => {
    const flap = document.createElement('span');
    flap.className = `pouches-counter__flap pouches-counter__flap--${position}`;
    const num = document.createElement('span');
    num.className = 'pouches-counter__num';
    num.textContent = '0';
    flap.appendChild(num);
    return flap;
  };

  const buildDigitCell = () => {
    const cell = document.createElement('span');
    cell.className = 'pouches-counter__digit';
    cell.dataset.value = '';
    cell.appendChild(buildHalf('top', '0'));
    cell.appendChild(buildHalf('bottom', '0'));
    cell.appendChild(buildFlap('top'));
    cell.appendChild(buildFlap('bottom'));
    return cell;
  };

  const buildSeparatorCell = () => {
    const separator = document.createElement('span');
    separator.className = 'pouches-counter__separator';
    separator.textContent = ',';
    return separator;
  };

  /** @param {number} value */
  const formatCounterValue = (value) => String(Math.max(0, Math.floor(value))).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  /** @param {HTMLElement} cell @param {string} newValue @param {boolean} animate */
  const setDigitValue = (cell, newValue, animate) => {
    const prev = cell.dataset.value || '';
    if (prev === newValue) return;

    const topHalfNum = /** @type {HTMLElement|null} */ (cell.querySelector('.pouches-counter__half--top .pouches-counter__num'));
    const bottomHalfNum = /** @type {HTMLElement|null} */ (cell.querySelector('.pouches-counter__half--bottom .pouches-counter__num'));
    const flapTop = /** @type {HTMLElement|null} */ (cell.querySelector('.pouches-counter__flap--top'));
    const flapBottom = /** @type {HTMLElement|null} */ (cell.querySelector('.pouches-counter__flap--bottom'));
    const flapTopNum = /** @type {HTMLElement|null} */ (flapTop?.querySelector('.pouches-counter__num') ?? null);
    const flapBottomNum = /** @type {HTMLElement|null} */ (flapBottom?.querySelector('.pouches-counter__num') ?? null);

    if (!topHalfNum || !bottomHalfNum || !flapTop || !flapBottom || !flapTopNum || !flapBottomNum) return;

    if (!animate || prev === '') {
      topHalfNum.textContent = newValue;
      bottomHalfNum.textContent = newValue;
      cell.dataset.value = newValue;
      return;
    }

    topHalfNum.textContent = newValue;
    flapTopNum.textContent = prev;
    flapBottomNum.textContent = newValue;

    flapTop.classList.remove('is-flipping');
    flapBottom.classList.remove('is-flipping');
    void flapTop.offsetWidth;
    flapTop.classList.add('is-flipping');
    flapBottom.classList.add('is-flipping');

    const onBottomEnd = () => {
      bottomHalfNum.textContent = newValue;
      flapTop.classList.remove('is-flipping');
      flapBottom.classList.remove('is-flipping');
      flapBottom.removeEventListener('animationend', onBottomEnd);
    };
    flapBottom.addEventListener('animationend', onBottomEnd);

    cell.dataset.value = newValue;
  };

  /** @param {HTMLElement} numberEl @param {number} value */
  const renderDigits = (numberEl, value) => {
    const str = formatCounterValue(value);
    const chars = str.split('');
    const animate = !numberEl.classList.contains('is-rolling');

    for (let i = 0; i < chars.length; i += 1) {
      const char = chars[i];
      const isSeparator = char === ',';
      const current = /** @type {HTMLElement|null} */ (numberEl.children[i] ?? null);
      const currentIsSeparator = current?.classList.contains('pouches-counter__separator') ?? false;

      if (!current) {
        numberEl.appendChild(isSeparator ? buildSeparatorCell() : buildDigitCell());
      } else if (isSeparator !== currentIsSeparator) {
        numberEl.replaceChild(isSeparator ? buildSeparatorCell() : buildDigitCell(), current);
      }
    }

    while (numberEl.childElementCount > chars.length) {
      numberEl.removeChild(/** @type {Node} */ (numberEl.lastChild));
    }

    for (let i = 0; i < chars.length; i += 1) {
      const char = chars[i];
      if (!char || char === ',') continue;
      const cell = /** @type {HTMLElement} */ (numberEl.children[i]);
      setDigitValue(cell, char, animate);
    }
  };

  /**
   * After the initial animation ends, increment the displayed number by 1
   * every 2 seconds to simulate live sales activity.
   * @param {HTMLElement} counterEl
   * @param {number} initialCount
   */
  const startAutoIncrement = (counterEl, initialCount) => {
    const numberEl = /** @type {HTMLElement|null} */ (counterEl.querySelector('[data-counter-number]'));
    if (!numberEl) return;

    let count = initialCount;
    setInterval(() => {
      count += 15;
      renderDigits(numberEl, count);
    }, 20000);
  };

  /** @param {HTMLElement} counterEl */
  const animateCounter = (counterEl) => {
    if (!counterEl || counterEl.dataset.counterAnimated === 'true') return;

    const numberEl = /** @type {HTMLElement|null} */ (counterEl.querySelector('[data-counter-number]'));
    const target = parseInt(counterEl.dataset.ordersCount || '', 10);
    if (!numberEl || Number.isNaN(target)) return;

    counterEl.dataset.counterAnimated = 'true';
    numberEl.classList.add('is-rolling');

    const duration = 1600;
    const start = Math.max(0, Math.floor(target * 0.72));
    const startTs = performance.now();

    /** @param {number} now */
    const tick = (now) => {
      const elapsed = now - startTs;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(start + (target - start) * ease);
      renderDigits(numberEl, current);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        renderDigits(numberEl, target);
        numberEl.classList.remove('is-rolling');
        startAutoIncrement(counterEl, target);
      }
    };

    requestAnimationFrame(tick);
  };

  const openKlaviyoForm = () => {
    const w = /** @type {any} */ (window);
    w._klOnsite = w._klOnsite || [];
    w._klOnsite.push(['openForm', 'S8Qwud']);
  };

  const initToggle = () => {
    const counter = /** @type {HTMLElement|null} */ (document.querySelector('.pouches-counter[data-orders-count]'));
    const tab = /** @type {HTMLElement|null} */ (document.querySelector('.pouches-counter__tab'));
    if (!counter || !tab || counter.dataset.toggleInit) return;
    counter.dataset.toggleInit = 'true';

    const closeBtn = counter.querySelector('.pouches-counter__close');
    closeBtn?.addEventListener('click', (event) => {
      event.stopPropagation();
      counter.classList.add('is-collapsed');
      tab.classList.add('is-visible');
    });

    counter.addEventListener('click', (event) => {
      const target = /** @type {HTMLElement} */ (event.target);
      if (closeBtn && (target === closeBtn || closeBtn.contains(target))) return;
      event.preventDefault();
      openKlaviyoForm();
    });

    tab.addEventListener('click', () => {
      tab.classList.remove('is-visible');
      counter.classList.remove('is-collapsed');
    });
  };

  const initCounters = () => {
    const counters = /** @type {NodeListOf<HTMLElement>} */ (
      document.querySelectorAll('.pouches-counter[data-orders-count]')
    );
    if (!counters.length) return;

    if (!('IntersectionObserver' in window)) {
      counters.forEach((counterEl) => animateCounter(counterEl));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const counterEl = /** @type {HTMLElement} */ (entry.target);
        animateCounter(counterEl);
        observer.unobserve(counterEl);
      });
    }, { threshold: 0.1 });

    counters.forEach((counterEl) => observer.observe(counterEl));

    initToggle();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }

  document.addEventListener('shopify:section:load', initCounters);
})();
